import React, { useState, useEffect } from 'react';
import api from '../api/axiosConfig';
import GoogleSignInButton from './GoogleSignInButton';
import { afterAuthPath } from '../utils/returnTo';
import { usePublicLanguage } from '../contexts/PublicLanguageContext';
import './LoginForm.css';

const LoginForm: React.FC = () => {
  const { t } = usePublicLanguage();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

      try {
        // Send 'username' field with email value
        const response = await api.post('/auth/token/', {
          username: email,  // Key must be 'username'
          password
        });

        //console.log('Login response:', response);
        //console.log('Token:', response.data.token);
        
        localStorage.setItem('token', response.data.token);
        //console.log('Token stored in localStorage');
        // Full navigation so App re-reads auth state from localStorage
        // (App is the Router's parent and won't re-render on client nav).
        // ?next= carries whoever arrived here from an invite link back to it.
        window.location.assign(afterAuthPath());
      } catch (err) {
        setError(t.auth.invalidCredentials);
      } finally {
        setIsLoading(false);
      }
  };

  return (
    <div className="login-form">
      <div className="login-container">
        <h2 className="login-title">{t.auth.loginTitle}</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-row">
            <label htmlFor="email">{t.auth.emailLabel}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-row">
            <label htmlFor="password">{t.auth.passwordLabel}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? t.auth.loggingIn : t.auth.loginButton}
          </button>
        </form>
        <GoogleSignInButton
          onSuccess={() => window.location.assign(afterAuthPath())}
          onError={(message) => setError(message)}
        />
        <div className="login-link-section">
          <span className="login-link-text">{t.auth.noAccount}</span>
          <a href={`/register${window.location.search}`} className="login-link">{t.auth.registerHere}</a>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;